export const FOLLOW_INTENT_KEY = "siis_pending_follow";

export type FollowIntent = {
  athleteId: string;
  athleteSlug: string;
  firstName: string;
  updatesConsent: true;
  newsletterConsent: boolean;
  nonce?: string;
};

export const saveFollowIntent = (intent: FollowIntent) => {
  window.localStorage.setItem(FOLLOW_INTENT_KEY, JSON.stringify(intent));
};

export const takeFollowIntent = (): FollowIntent | null => {
  const raw = window.localStorage.getItem(FOLLOW_INTENT_KEY);
  if (!raw) return null;
  window.localStorage.removeItem(FOLLOW_INTENT_KEY);
  try {
    const value = JSON.parse(raw) as Partial<FollowIntent>;
    if (!value.athleteId || !value.athleteSlug || value.updatesConsent !== true) return null;
    return {
      athleteId: value.athleteId,
      athleteSlug: value.athleteSlug,
      firstName: typeof value.firstName === "string" ? value.firstName.slice(0, 80) : "",
      updatesConsent: true,
      newsletterConsent: value.newsletterConsent === true,
      nonce: typeof value.nonce === "string" ? value.nonce : undefined,
    };
  } catch {
    return null;
  }
};